<template>
  <div>
    <el-dialog custom-class="editor-dialog" :center="center" :close-on-click-modal="closeOnClickModal" :width="width" :visible="dialogVisible" top="3vh"
      :z-index="2000" :before-close="handleClose" @open="onDialogOpen">
      <template #title>
        <span>{{dialogTitle}}</span>
      </template>
      <div class="backgroud-white cs-editor-content" v-loading="loading">
        <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="110px">
          <el-form-item label="序号" prop="Index">
            <el-input placeholder="请输入序号" size="small" :disabled="isFieldsDisabled" v-model="model.Index" class="input-width"
              oninput="value=value.replace(/[^0-9]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(0):null">
            </el-input>
          </el-form-item>
          <el-form-item label="名称" prop="Name">
            <el-input placeholder="请输入名称" :disabled="isFieldsDisabled" v-model="model.Name" class="input-width" />
          </el-form-item>
          <el-form-item label="课程类型">
            <el-select placeholder="请选择课程类型" :multiple="true" :disabled="isFieldsDisabled" v-model="model.CourseBasicCategories">
              <el-option v-for="(item, index) in GLOBAL.enumCourseBasicCategory.selectListItems" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="描述" prop="Description" style="margin-bottom: 20px;">
            <el-input type="textarea" :rows="6" resize="none" placeholder="请输入描述" :disabled="readonly" v-model="model.Description" class="input-width" />
          </el-form-item>
          <el-form-item prop="StartTime" label="开始日期">
            <el-date-picker type="date" align="center" placeholder="选择开始日期" format="yyyy/MM/dd" :disabled="readonly" v-model="model.StartTime"
              class="input-width"></el-date-picker>
          </el-form-item>
          <el-form-item prop="EndTime" label="结束日期">
            <el-date-picker type="date" align="center" placeholder="选择结束日期" format="yyyy/MM/dd" :disabled="readonly" v-model="model.EndTime"
              class="input-width"></el-date-picker>
          </el-form-item>
          <el-form-item v-if="isEdit" label="启用状态">
            <el-select placeholder="请选择启用状态" :disabled="readonly" v-model="model.Enable">
              <el-option key="0" label="启用" :value="true" />
              <el-option key="1" label="停用" :value="false" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer popup-footer">
          <el-row v-if="!readonly">
            <el-col>
              <el-button :disabled="readonly || loading || isSaving" :loading="isSaving" type="primary" @click="saveChanges">确认</el-button>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { saveQuestionnaire } from "@/service/questionnaire.service";

const default_dataModel = {
  Id: 0,
  Enable: true,
  TermId: 0,
  Index: null,
  Name: null,
  Description: null,
  StartTime: null,
  EndTime: null,
  HaveStudentRecords: false,
};

const mixin_generalMethods = {
  methods: {
    validate() {
      let isValid = true;

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      return isValid;
    },
  },
};

export default {
  name: "questionnaireEditor",
  mixins: [mixin_generalMethods],
  components: {},
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "50%",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return Object.clone(default_dataModel);
      },
    },
    termId: {
      type: Number,
      default: 0,
    },
    maxIndex: {
      type: Number,
      default: null,
    },
    customValidator: {
      type: Function,
      default: null,
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    const indexValidator = (rule, value, callback) => {
      let message = "";

      if (!!this.customValidator) {
        let fixedValue = `${value}`.toNumber();
        let fieldName = "Index";
        let result = this.customValidator(fixedValue, fieldName, this.model);
        if (!!result[fieldName] && !result[fieldName].success) {
          message = result[fieldName].message;
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    const endTimeValidator = (rule, value, callback) => {
      let message = "";

      if (!!value) {
        if (value < this.model.StartTime) {
          message = "结束日期不能早于开始日期";
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      isSaving: false,
      dialogVisible: false,
      rules: {
        Index: [
          {
            required: true,
            message: "请输入序号",
            trigger: "blur",
          },
          {
            validator: indexValidator,
            trigger: "blur",
          },
        ],
        Name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        StartTime: [
          {
            required: true,
            message: "请输入开始日期",
            trigger: "blur",
          },
        ],
        EndTime: [
          {
            validator: endTimeValidator,
            trigger: "blur",
          },
        ],
      },
      model: Object.clone(default_dataModel),
    };
  },
  created() {
    this.reloadVisible();
  },
  computed: {
    isEdit() {
      return !!this.data && !!this.data.Id;
    },
    isFieldsDisabled() {
      if (this.readonly) return true;

      return !!this.data && this.data.HaveStudentRecords;
    },
    dialogTitle() {
      let baseValue = "问卷";
      if (this.isFieldsDisabled) return `查看${baseValue}`;
      if (this.isEdit) return `编辑${baseValue}`;
      return `添加${baseValue}`;
    },
  },
  methods: {
    // 和服务端进行数据交互相关方法
    async saveQuestionnaireToServer() {
      this.isSaving = true;

      let saveData = Object.clone(this.model);
      saveData.Index = `${saveData.Index}`.toNumber();
      let startTimeText = this.$moment(saveData.StartTime).format(
        this.GLOBAL.MomentDateFormatISO
      );
      saveData.StartTime = this.$moment.utc(startTimeText);
      if (!!saveData.EndTime) {
        let endTimeText = this.$moment(saveData.EndTime).format(
          this.GLOBAL.MomentDateFormatISO
        );
        saveData.EndTime = this.$moment.utc(endTimeText);
      }
      if (!this.isEdit) {
        saveData.TermId = this.termId;
      }

      try {
        let result = await saveQuestionnaire(saveData);
        if (!!result && result.success) {
          this.model.Id = result.data;
          this.$message({
            message: "保存问卷成功",
            type: "success",
          });
          this.$emit("change", saveData);
          return true;
        } else {
          this.$message({
            message: result.message || "保存问卷失败",
            type: "error",
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isSaving = false;
      }

      return false;
    },

    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible === newValue) return;

      this.dialogVisible = newValue;
      if (this.dialogVisible) this.reloadDataFromProps();
    },
    clearValidate() {
      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        try {
          refForm.clearValidate();
        } catch (error) {}
      }
    },
    resetData() {
      this.model = Object.clone(default_dataModel);

      this.$nextTick(() => {
        this.clearValidate();
      });
    },
    async reloadDataFromProps() {
      if (!this.dialogVisible) return;
      
      this.model = Object.clone(this.data || default_dataModel);
      if (!!this.model.StartTime) {
        let startTimeText = this.$moment(this.model.StartTime).format(
          this.GLOBAL.MomentDateFormatISO
        );
        this.model.StartTime = this.$moment(startTimeText).toDate();
      }
      if (!!this.model.EndTime) {
        let endTimeText = this.$moment(this.model.EndTime).format(
          this.GLOBAL.MomentDateFormatISO
        );
        this.model.EndTime = this.$moment(endTimeText).toDate();
      }

      if (!this.isEdit && (!!this.maxIndex || this.maxIndex === 0)) {
        this.model.Index = this.maxIndex + 1;
      }
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    async closeDialog() {
      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.reloadDataFromProps();
    },
    handleClose(done) {
      this.$nextTick(() => {
        this.resetData();

        this.closeDialog();
      });
    },
    async saveChanges() {
      let isValid = this.validate();
      if (!isValid) return;

      let result = await this.saveQuestionnaireToServer();
      if (result) this.closeDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
body .popup-footer{
  margin-top: 0;
}
.el-dialog__wrapper {
  /deep/ .editor-dialog {
    min-width: 400px;

    .el-dialog__header {
      font-size: 1.75em;
      font-weight: bold;
    }

    .el-dialog__body{
      padding-bottom: 0;
    }
  }
}

.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .el-form-item {
    margin-bottom: 12px;

    .input-width {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/questionnaire/questionnaireEditor.vue